module.exports = __webpack_public_path__ + "img/calendar_month.411a653b.svg";